<div class="contactDialogWrap">
  <button class="close" mat-button mat-dialog-close type="button" (click)="matDialog.closeAll()">
    <mat-icon>close</mat-icon>
  </button>
  <div>
    <h3 mat-dialog-title>Contact Agent</h3>
    <div mat-dialog-content></div>
    <br />
    <div>
      <app-progress-indicator *ngIf="isLoadingAgentDetails" text="Please wait while we load"></app-progress-indicator>
      <div class="row mb-4 contact-details">
        <div class="col-md-3 col-sm-3 col-xs-3">
          <img class="agent-img" height="60" [src]="connectedAgent?.profileImage || defaultProfileImage" />
        </div>
        <div class="col-md-9 col-sm-9 col-xs-9 pr-2 pl-2">
          <h4 class="w-100 mb-1">{{ connectedAgent?.firstName + ' ' + connectedAgent?.lastName }}</h4>
          <!-- <p class="mb-1">San Ramon Real Estate Agent</p> -->
          <p class="mb-1">
            {{ connectedAgent?.firstName + ' ' + connectedAgent?.lastName }} typically replies in about <br />
            <span>60 minutes</span>
          </p>
        </div>
      </div>
      <div class="row">
        <mat-form-field class="col-lg-12">
          <mat-label>Message</mat-label>
          <textarea
            matInput
            rows="4"
            (keypress)="onTypeMessage()"
            [(ngModel)]="selectedMessageValue"
            placeholder="Write a Message..."
          ></textarea>
          <span style="color: red" *ngIf="noMessageFound">Message is required </span>
        </mat-form-field>
      </div>
      <div class="suggestedMessagesButtons flex cols-2">
        <div
          class="suggestedMessageButtonWrapper"
          *ngFor="let message of isDashboard ? dashboardMessages : suggestedMessages"
        >
          <button
            type="button"
            class="suggestedMessageButton"
            (click)="selectedMessage(message)"
            [ngClass]="{ 'selected-item': message === selectedMessageValue }"
          >
            <span class="ButtonLabel"
              ><span class="suggestedMessage">{{ message }}</span></span
            >
          </button>
        </div>
      </div>

      <div mat-dialog-actions class="my-4">
        <div class="w-100 text-right">
          <!-- <button mat-button mat-dialog-close type="button" [disabled]="mortgageCreationInProgress"
          (click)="proceedCancelAction()">Cancel</button> -->
          <button
            class="ml-2"
            mat-flat-button
            color="primary"
            [pmx-progress-button]="isLoadingSubmitButton"
            (click)="notifyAgent()"
            type="submit"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
